import { Input, Label, Select } from '@/components/ui'
import { useValuationStore } from '@/store/valuationStore'
import { PROPERTY_TYPE_OPTIONS } from '@/data/opzioni-immobile'


export function PropertyStep() {
  const { formData, updateFormData } = useValuationStore()

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Dettagli dell'immobile</h2>
        <p className="mt-1 text-gray-600">
          Inserisci le informazioni di base sulla proprieta
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label htmlFor="propertyType" required>
            Tipo di immobile
          </Label>
          <Select
            id="propertyType"
            value={formData.propertyType || 'appartamento'}
            onChange={(e) => updateFormData({ propertyType: e.target.value })}
            options={PROPERTY_TYPE_OPTIONS}
          />
        </div>

        <div>
          <Label htmlFor="area" required>
            Superficie (mq)
          </Label>
          <Input
            id="area"
            type="number"
            min={10}
            max={1000}
            value={formData.area || ''}
            onChange={(e) => updateFormData({ area: parseInt(e.target.value) || 0 })}
            placeholder="Es. 80"
          />
        </div>

        <div>
          <Label htmlFor="rooms">
            Numero di stanze
          </Label>
          <Input
            id="rooms"
            type="number"
            min={1}
            max={20}
            value={formData.rooms || ''}
            onChange={(e) => updateFormData({ rooms: parseInt(e.target.value) || undefined })}
            placeholder="Es. 3"
          />
        </div>

        <div>
          <Label htmlFor="bathrooms">
            Numero di bagni
          </Label>
          <Input
            id="bathrooms"
            type="number"
            min={1}
            max={10}
            value={formData.bathrooms || ''}
            onChange={(e) => updateFormData({ bathrooms: parseInt(e.target.value) || undefined })}
            placeholder="Es. 2"
          />
        </div>
      </div>
    </div>
  )
}
